import styled from "styled-components";

export const DivMainHorarioAgendamentoTreinamento = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
`;

export const DivMainHorariosLivres = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: min-content;
`;

export const DivTitulo = styled.div`
    position: sticky;
    top: 0;
    background: inherit;

    padding: 35px;
`;

export const DivHorario = styled.div`
    width: fit-content;
    background: #007bff;
    padding: 10px;
    border-radius: 4px;
    color: #fefefe;
    transition: 0.5s;
    cursor: default;
    margin: 0px 0px 8px 0;
    :hover {
        transform: scale(1.08);
    }
`;

export const DivContentElements = styled.div`
    display: flex;
    flex-direction: column;
`;

export const InputText = styled.input`
    height: 35px;
    font-size: 16px;
    padding: 0 0 0 6px;
    min-width: 350px;
    margin: 12px 0;
`;

export const SpanTitulo = styled.span`
    font-size: 16px;
`;

export const SpanHorarioSelecionado = styled.span`
    display: ${(props) => (props.mostrar ? "block" : "none")};
    font-size: 16px;
    margin: 0 0 12px 0;
`;

export const PopupHorarios = styled.div`
    width: 100%;
    height: 100%;
    display: ${(props) => (props.mostraPopup ? "flex" : "none")};
    position: absolute;
    background: #000000c2;
    top: 0;
    justify-content: center;
    align-items: center;
`;

export const DivMainPopupHorarios = styled.div`
    background: #fff;
    height: fit-content;
    width: fit-content;
    max-height: 80%;
    max-width: 80%;
    overflow: hidden auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
    position: relative;
`;

export const ButtonInfo = styled.button`
    display: ${(props) => (props.mostrar ? "block" : "none")};
    width: fit-content;
    padding: 12px;
    color: #fef;
    background: #007bff;
    border: 0;
    align-self: center;
`;
export const SpanBotaoClose = styled.span`
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: default;
`;

export const SelectTipoAgendamento = styled.select`
    height: 35px;
    font-size: 16px;
    padding: 0 0 0 6px;
    min-width: 350px;
    margin: 12px 0;
`;

export const ButtonSucess = styled.button`
    width: fit-content;
    padding: 12px;
    color: #fef;
    background: #007bff;
    border: 0;
    align-self: center;
`;

export const DivHorariosDisponiveis = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 12px 0;
    width: 100%;
    justify-content: space-between;
`;
export const H1TituloHorarios = styled.h1`
    font-size: 23px;
`;
export const DivMainAgendamentoSucesso = styled.div`
    background: rgb(255, 255, 255);
    padding: 100px 190px;
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    align-items: center;
`;

export const PAgendamentoSucesso = styled.p`
    font-size: 25px;
    margin: 20px 0;
`;

export const ButtonAgendamentoSucesso = styled.button`
    background: green;
    border: 0;
    padding: 10px 20px;
    border-radius: 6px;
    color: #fff;
    font-size: 18px;
`;
